import { cond, stubTrue } from 'lodash-es'
import { createWithEqualityFn as create } from 'zustand/traditional'

import { AddFormState, FormType } from '@/lib/features/Assets/components/AddAssetModal/interfaces'

export type AssetFormState = Omit<AddFormState, 'status'> & {
  isSubmitting: boolean

  setIsSubmitting: (isSubmitting: boolean) => void
  setType: (formType: FormType) => void
  setErrors: (errors: AddFormState['errors']) => void
  reset: () => void
  openModal: () => void
  closeModal: () => void
  setState: (state: AddFormState['state']) => void
  updateState: (state: Partial<AddFormState['state']>) => void
  setSelectedOption: (option: AddFormState['selectedOption']) => void
  lockFormType: (formType: FormType) => void
  releaseFormType: (formType: FormType) => void
  releaseAllFormTypes: () => void
}
const stepByFormType = {
  [FormType.PTU]: 0,
  [FormType.SELECT_TYPE]: 0,
  [FormType.VEHICLE_BASIC]: 1,
  [FormType.VEHICLE_DETAIL]: 2,
}

const initialState = {
  errors: null,
  formType: FormType.SELECT_TYPE,
  isOpen: false,
  lockedForms: [],
  selectedOption: null,
  state: {},

  isSubmitting: false,

  steps: null,
}

export const useAssetFormState = create<AssetFormState>((set, _get) => ({
  ...initialState,

  reset: () => set(initialState),
  openModal: () => set({ isOpen: true }),
  closeModal: () => set(initialState),

  setState: (state) => set({ state }),
  updateState: (state) => set((prev) => ({ state: { ...prev.state, ...state } })),
  setSelectedOption: (selectedOption) => set({ selectedOption }),

  setErrors: (errors) => set({ errors }),

  setType: (formType: FormType) =>
    set(() => ({
      formType,
      ...cond<FormType, { steps?: AssetFormState['steps'] }>([
        [
          (v) => [FormType.VEHICLE_BASIC, FormType.VEHICLE_DETAIL].includes(v),
          (v) => ({
            steps: {
              current: stepByFormType[v],
              total: 2,
            },
          }),
        ],
        [
          (v: FormType) => [FormType.SELECT_TYPE, FormType.PTU].includes(v),
          () => ({
            steps: null,
          }),
        ],
        [stubTrue, () => ({})],
      ])(formType),
    })),
  setIsSubmitting: (isSubmitting) => set({ isSubmitting }),

  lockFormType: (formType) =>
    set((state) => ({
      lockedForms: [...state.lockedForms, formType],
    })),
  releaseFormType: (formType) =>
    set((state) => ({
      lockedForms: state.lockedForms.filter((lockedForm) => lockedForm !== formType),
    })),
  releaseAllFormTypes: () => set({ lockedForms: [] }),
}))
